import * as React from 'react'
import {IPatientIdStore} from '../../stores/PatientIdStore'
import {P} from '../../atoms/P'
import styled from 'styled-components'
import {media} from '../../utils/media'
import {Button} from '../../atoms/Button'
import {findIntakeWithIdQuery_findIntakeWithId} from '../../schema/schemaTypes'
import {patientInfo as dynamicInfo} from '../Intakes/intakeMetrics/calcIntakeMetrics'
import PrintHeader from '../../atoms/PrintHeader/PrintHeader'
import PrintFooter from '../../atoms/PrintFooter/PrintFooter'

interface IInputProps {
  patientIdStore?: IPatientIdStore
}

export class Hcp31View extends React.Component<IInputProps, findIntakeWithIdQuery_findIntakeWithId> {
  public state: findIntakeWithIdQuery_findIntakeWithId

  public async componentWillMount() {
    const intake = JSON.parse(localStorage.getItem('patientIntake')!)
    if (intake) {
      this.setState(intake)
    }
  }

  public render() {
    const patientInfo = dynamicInfo(this.state)

    return (
      <div>
        <PrintHeader/>
        <RowTablet>
          <div>
            <H2>Patient Information</H2>
            <P style={{fontWeight: 'bold', marginBottom: 15}}>Here is some information about the anxiety level and
              coping style of {this.state.childFirstName} {this.state.childLastName} and their parent that you may
              find helpful</P>
            <P>{patientInfo.childAnxietyText}</P>
            <P>{patientInfo.parentAnxietyText}</P>
            <P>{patientInfo.parentWillingText}</P>
            <H2 style={{marginTop: 30}}>Distraction Information</H2>
            <P style={{fontWeight: 'bold'}}>Child's Name: {this.state.childFirstName} {this.state.childLastName}</P>
            <P>Child's Nickname: {this.state.childNickname}</P>
            <P>Favorite Toys: {this.state.childFavoriteToys}</P>
            <P>Favorite Games: {this.state.childFavoriteGames}</P>
            <P>Movies: {this.state.childEnjoysMovies}</P>
            <P>Pets: {this.state.childPets}</P>
            <P>Sports/Extracurricular Activities: {this.state.childSportsOrExtracurricular}</P>
          </div>
          <ColRight>
          <Button onClick={() => {
            (window as any).trackPrint('HCP3.pdf','HCP3')
            window.print()
          }}>PRINT</Button>
          </ColRight>
        </RowTablet>
        <PrintFooter name="Patient Information"/>
      </div>
    )
  }
}

const H2 = styled.h2`
  font-family: Nunito;
  font-size: 22px;
  font-weight: 900;
  color: #12385b;
`

const RowTablet = styled.div`
  ${media.tablet`
    margin-top: 50px;
    display: flex;
    justify-content: space-between;
  `}
  margin-bottom: 50px;
`

const ColRight = styled.div`
  margin-top: 30px;
  ${media.tablet`
    margin-top:0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  `}
`



// WEBPACK FOOTER //
// ./src/organisms/HCP3-1/HCP3_1_View.tsx